import React, {  } from 'react';
import {Field, ErrorMessage } from 'formik';
import  {Box, Alert} from '@mui/material/';
import '../../../../css/report.css'



function CheckboxGroup(props) {
    const { label, name, optionObject, ...rest } = props.symptom
    return (
        <Box  className="checkboxContainer"  >
        <label> {label} </label>
        <Field  name={name} {...rest}>
{({field }) => {
         return optionObject.map( (option) =>{
            return (
                <React.Fragment key = {`${name}${option.key}`}>
                    <p className="checkboxItem">
                    <input
                    type = "checkbox"
                    id =  {`${name}${option.value}`}
                    {...field}
                    value = {option.value}
                    checked = {field.value.includes(option.value)}
                    />
                <label htmlFor = {option.value}> {option.key} </label>
                </p>
                </React.Fragment>
                )
            })
        }}
       </Field>
       <ErrorMessage name={name} >
            {errorMsg => <Alert severity='error' >{errorMsg}</Alert>}
          </ErrorMessage>
        </Box>
     
     );
}

export default CheckboxGroup;
